import { TestContext } from 'yup';
import { AnyObject } from 'yup/lib/types';
import { UserQuotaStatusDto } from 'app/interfaces/dto/user-quota-status.dto';
import { formatCurrency } from 'shared/utils';
import { MAIN_CURRENCY } from '@okletsplay/core';
import { QuotaOperation } from '../enums';
import pluralize from 'pluralize';
import { upperFirst } from 'lodash';

type Context = TestContext<AnyObject>;

interface Options {
  getQuotas: () => UserQuotaStatusDto | undefined;
  context: Context;
  mainCurrencyAmount: number;
  quotaOperation: QuotaOperation;
}

export const quotasValidator = ({
  getQuotas,
  context,
  mainCurrencyAmount,
  quotaOperation,
}: Options) => {
  const quotas = getQuotas();

  if (!quotas) {
    throw context.createError({ message: 'Something went wrong, try later' });
  }

  const { available, provided } = quotas;

  if (available.dailyAmount > 0 && available.dailyCount === 0) {
    throw context.createError({
      message: `You've reached daily quota limit: ${available.dailyCount} ${pluralize(
        quotaOperation
      )} of ${provided.dailyCount} total.`,
    });
  }

  const validateAmount = (availableAmount: number, providedAmount: number, period: string) => {
    if (mainCurrencyAmount > availableAmount) {
      throw context.createError({
        message: `${period} quota limit: ${availableAmount} of ${formatCurrency(
          providedAmount,
          MAIN_CURRENCY
        )} total.`,
      });
    }
  };

  validateAmount(available.monthlyAmount, provided.monthlyAmount, 'Monthly');
  validateAmount(available.weeklyAmount, provided.weeklyAmount, 'Weekly');
  validateAmount(available.dailyAmount, provided.dailyAmount, 'Daily');

  if (!quotas.allowed) {
    throw context.createError({ message: `${upperFirst(quotaOperation)} quota limit reached` });
  }
};
